import { FluentProvider, Spinner, tokens } from '@fluentui/react-components';
import { useActiveTheme } from '../theme/ThemeContext';

interface UniversalLoadingProps {
  label?: string;
}

const UniversalLoading = ({
  label = 'Getting things ready…',
}: UniversalLoadingProps) => {
  const theme = useActiveTheme();
  return (
    <FluentProvider theme={theme}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <Spinner size="large" />
        <span style={{ color: tokens.colorNeutralForeground3, fontSize: 14 }}>
          {label}
        </span>
      </div>
    </FluentProvider>
  );
};

export default UniversalLoading;
